const RECENTLY_VIEWED_LIMIT = 12
const RECENTLY_VIEWED_KEY = 'recently_viewed'

class RecentlyViewed extends window.BAO.CustomElement() {
  static get requiredAttributes () {
    return ['handle']
  }

  connectedCallback () {
    super.connectedCallback()

    this.storeHandle()
  }

  /**
   * @returns {string} The handle of the product currently being viewed
   */
  get handle () {
    return this.getAttribute('handle')
  }

  /**
   * @returns {string[]} Previously viewed handles, most recent first
   */
  get viewedHandles () {
    return (this.getAttribute('viewed') || '')
      .split(',')
      .map(handle => handle.trim())
      .filter(Boolean)
  }

  async storeHandle () {
    const handle = this.handle
    if (!handle) return

    const viewed = this.viewedHandles

    // Already the most recent, so there is nothing worth writing
    if (viewed[0] === handle) return

    const handles = [handle, ...viewed.filter(item => item !== handle)].slice(
      0,
      RECENTLY_VIEWED_LIMIT,
    )

    try {
      await window.BAO.Cart.updateCartAttributes(
        { [RECENTLY_VIEWED_KEY]: handles.join(',') },
        { sections: [] },
      )
    } catch (error) {
      console.error('Recently viewed: unable to store product', error)
    }
  }
}

if (!customElements.get('recently-viewed')) {
  customElements.define('recently-viewed', RecentlyViewed)
}
